import { SelectOption } from "@/rca-types";
import { CaseStatus } from "./constants";

export const ResolveFlowOptions = {
  TRAINING_NEEDED: "Training needed",
  UNREASONABLE_COMPENSATION: "Unreasonable compensation",
  NO_RISK_IDENTIFICATION: "No risk identified",
  RISK_IDENTIFICATION: "Risk identified",
  TRAINING_NEEDED_REGD_REAS_COMP:
    "Training needed regarding reasonable compensation",
  OTHER: "Other",
  MISSING_CUSTOMER_DATA: "Missing customer data",
  MISSING_FIRST_NAME: "Missing first name",
  MISSING_LAST_NAME: "Missing last name",
  MISSING_ZIP_CODE: "Missing zip code",
  MISSING_PHONE_NUMBER: "Missing phone number",
  MISSING_ADDRESS: "Missing address",
  INCORRECT_LABEL_TYPE: "Incorrect label type",
  MISSING_COMMENTS: "Missing comment",
  INSUFFICIENT_COMMENT: "Insufficient comment",
  COMP_CALCULATED_CORRECTLY: "Compensation calculated correctly",
  FRAUDULENT_CO_WORKER_BEHAVIOUR: "Fraudulent co-worker behaviour",
  FRAUDULENT_CUSTOMER_BEHAVIOUR: "Fraudulent customer behaviour",
  LOCAL_STORE_WORKAROUND: "Local store workaround",
  CUSTOMER_IN_FOCUS: "Customer in focus",
  NEEDS_FURTHER_REVIEW: "Needs further review",
  NEEDS_FURTHER_REVIEW_BY_SS_MEMBER: "Needs further review by S&S Team-member",
  NON_FRAUDULENT_BEHAVIOUR: "Non fraudulent behaviour",
  TRAINING_REGD_METHOD_DEVIATION: "Training regarding method deviation",
  OTHER_TRAINING: "Other training",
  INVESTIGATION_ID_PARTIAL_FRAUD:
    "Investigation identified potentially fraudulent activity",
  MULTIPLE_INFO_FIELD_MISSING: "Multiple information fields missing",
  REVIEWED_CUSTOMER_HISTORY: "Reviewed customer’s return transactions history",
  FRAUDULENT_CO_WORKER_BEHAVIOR: "Fraudulent co-worker behavior",
  FRAUDULENT_CUSTOMER_BEHAVIOR: "Fraudulent customer behavior"
};

export const TENDER_DEVIATION_HEADERS_CO_WORKER = [
  {
    text: "Return ID",
    align: "start",
    value: "return_id",
    class: "case-list-header-cell"
  },
  {
    text: "Return Date",
    value: "created",
    class: "case-list-header-cell",
    //   filter: this.filterColumnLookBack,
    sort: (a: any, b: any) => {
      const dateA = new Date(a);
      const dateB = new Date(b);
      if (dateA < dateB) return 1;
      if (dateA == dateB) return 0;
      return -1;
    }
  },
  {
    text: "Risk",
    value: "risk_level",
    class: "case-list-header-cell"
    //   filter: this.filterColumnRiskScore
  },
  {
    text: "Risk Reason",
    value: "risk_reason",
    class: "case-list-header-cell"
    //   filter: this.filterColumnRiskPattern
  },
  {
    text: "Purchase Tender",
    value: "purchase_tender_type",
    class: "case-list-header-cell do-not-translate"
    //   filter: this.filterColumnReasonCode
  },
  {
    text: "Return Tender",
    value: "tender_type",
    class: "case-list-header-cell do-not-translate"
    //   filter: this.filterColumnReasonCode
  },
  {
    text: "Return Amount",
    value: "tender_amount",
    class: "case-list-header-cell"
    //   filter: this.filterColumnReasonCode
  },
  {
    text: "Status",
    value: "status",
    class: "case-list-header-cell"
    //   filter: this.filterColumnStatus
  },
  { text: "Accept", value: "accept", class: "case-list-header-cell" },
  { text: "Review", value: "review", class: "case-list-header-cell" }
];

export const TENDER_DEVIATION_HEADERS_S_S_TM = [
  {
    text: "Return ID",
    align: "start",
    value: "return_id",
    class: "case-list-header-cell"
  },
  {
    text: "Date Created",
    value: "created",
    class: "case-list-header-cell",
    //   filter: this.filterColumnLookBack,
    sort: (a: any, b: any) => {
      const dateA = new Date(a);
      const dateB = new Date(b);
      if (dateA < dateB) return 1;
      if (dateA == dateB) return 0;
      return -1;
    }
  },
  {
    text: "Risk",
    value: "risk_level",
    class: "case-list-header-cell"
    //   filter: this.filterColumnRiskScore
  },
  {
    text: "Risk Reason",
    value: "risk_reason",
    class: "case-list-header-cell"
    //   filter: this.filterColumnRiskPattern
  },
  {
    text: "Original Tender",
    value: "purchase_tender_type",
    class: "case-list-header-cell  do-not-translate"
    //   filter: this.filterColumnReasonCode
  },
  {
    text: "New Tender",
    value: "tender_type",
    class: "case-list-header-cell do-not-translate"
    //   filter: this.filterColumnReasonCode
  },
  {
    text: "Return Amount",
    value: "tender_amount",
    class: "case-list-header-cell"
    //   filter: this.filterColumnReasonCode
  },
  {
    text: "Co-worker ID",
    value: "co-worker",
    class: "case-list-header-cell"
    //   filter: this.filterColumnStatus
  },
  {
    text: "Status",
    value: "status",
    class: "case-list-header-cell"
    //   filter: this.filterColumnStatus
  }
];

export const nonSubstantiatedResult: SelectOption[] = [
  {
    text: ResolveFlowOptions.TRAINING_NEEDED,
    value: ResolveFlowOptions.TRAINING_NEEDED
  },
  {
    text: ResolveFlowOptions.LOCAL_STORE_WORKAROUND,
    value: ResolveFlowOptions.LOCAL_STORE_WORKAROUND
  },
  {
    text: ResolveFlowOptions.CUSTOMER_IN_FOCUS,
    value: ResolveFlowOptions.CUSTOMER_IN_FOCUS
  },
  {
    text: ResolveFlowOptions.OTHER,
    value: ResolveFlowOptions.OTHER
  },
  {
    text: ResolveFlowOptions.NO_RISK_IDENTIFICATION,
    value: ResolveFlowOptions.NO_RISK_IDENTIFICATION
  }
];

export const CoWorkerSubstantiated: SelectOption[] = [
  {
    text: ResolveFlowOptions.NEEDS_FURTHER_REVIEW,
    value: ResolveFlowOptions.NEEDS_FURTHER_REVIEW
  }
];

export const CoWorkerSubstantiated1: SelectOption[] = [
  {
    text: "Customer information not entered",
    value: "Customer information not entered"
  },
  {
    text: "Payment method deviation",
    value: "Payment method deviation"
  },
  {
    text: "Customer care history not investigated",
    value: "Customer care history not investigated"
  },
  {
    text: "Unreasonable article/ non-article compensation",
    value: "Unreasonable article/ non-article compensation"
  },
  {
    text: "Sales group 80 - Article not defined",
    value: "Sales group 80 - Article not defined"
  },
  {
    text: "Unreasonable price adjustment",
    value: "Unreasonable price adjustment"
  },
  {
    text: "Other",
    value: "Other"
  }
];

export const SSTeamMemNonSubstantiated: SelectOption[] = [
  {
    text: ResolveFlowOptions.NON_FRAUDULENT_BEHAVIOUR,
    value: ResolveFlowOptions.NON_FRAUDULENT_BEHAVIOUR
  }
];

export const SSTeamMemSubstantiated: SelectOption[] = [
  {
    text: ResolveFlowOptions.FRAUDULENT_CUSTOMER_BEHAVIOUR,
    value: ResolveFlowOptions.FRAUDULENT_CUSTOMER_BEHAVIOUR
  },
  {
    text: ResolveFlowOptions.FRAUDULENT_CO_WORKER_BEHAVIOUR,
    value: ResolveFlowOptions.FRAUDULENT_CO_WORKER_BEHAVIOUR
  },
  {
    text: ResolveFlowOptions.OTHER,
    value: ResolveFlowOptions.OTHER
  }
];

export const SSTeamMemSubstantiatedSG80: SelectOption[] = [
  {
    text: ResolveFlowOptions.FRAUDULENT_CO_WORKER_BEHAVIOUR,
    value: ResolveFlowOptions.FRAUDULENT_CO_WORKER_BEHAVIOUR
  },
  {
    text: ResolveFlowOptions.OTHER,
    value: ResolveFlowOptions.OTHER
  }
];

export const ControlDetailedReasonCodes: any = {
  training_needed: [
    {
      text: ResolveFlowOptions.TRAINING_REGD_METHOD_DEVIATION,
      value: ResolveFlowOptions.TRAINING_REGD_METHOD_DEVIATION
    },
    {
      text: ResolveFlowOptions.OTHER_TRAINING,
      value: ResolveFlowOptions.OTHER_TRAINING
    }
  ],
  needs_review: [
    {
      text: ResolveFlowOptions.NEEDS_FURTHER_REVIEW_BY_SS_MEMBER,
      value: ResolveFlowOptions.NEEDS_FURTHER_REVIEW_BY_SS_MEMBER
    },
    {
      text: ResolveFlowOptions.INVESTIGATION_ID_PARTIAL_FRAUD,
      value: ResolveFlowOptions.INVESTIGATION_ID_PARTIAL_FRAUD
    }
  ]
};

export const statusForCoWorker: string[] = [
  CaseStatus.NEW,
  CaseStatus.CHECK_LATER,
  CaseStatus.INREVIEW,
  CaseStatus.CLOSED
];

export const defaultStatusFilterCoWorker: SelectOption[] = [
  {
    text: CaseStatus.NEW,
    value: CaseStatus.NEW
  },
  {
    text: CaseStatus.CHECK_LATER,
    value: CaseStatus.CHECK_LATER
  }
];

export const defaultStatusFilterSSTeamMem: SelectOption[] = [
  {
    text: CaseStatus.INREVIEW,
    value: CaseStatus.INREVIEW
  }
];

export const statusForSSTeamMember: string[] = [
  CaseStatus.INREVIEW,
  CaseStatus.CLOSED
];

export const conditionForDetailedExp: string[] = [
  ResolveFlowOptions.TRAINING_NEEDED,
  ResolveFlowOptions.NEEDS_FURTHER_REVIEW
];

export const nonSubstantiatedResultANA: SelectOption[] = [
  {
    text: ResolveFlowOptions.TRAINING_NEEDED,
    value: ResolveFlowOptions.TRAINING_NEEDED
  },
  {
    text: ResolveFlowOptions.NO_RISK_IDENTIFICATION,
    value: ResolveFlowOptions.NO_RISK_IDENTIFICATION
  }
];

export const nonSubstantiatedResultRPA: SelectOption[] = [
  {
    text: ResolveFlowOptions.TRAINING_NEEDED,
    value: ResolveFlowOptions.TRAINING_NEEDED
  },
  {
    text: ResolveFlowOptions.NO_RISK_IDENTIFICATION,
    value: ResolveFlowOptions.NO_RISK_IDENTIFICATION
  },
  {
    text: ResolveFlowOptions.OTHER,
    value: ResolveFlowOptions.OTHER
  }
];

export const conditionForDetailedExpANA: string[] = [
  ResolveFlowOptions.TRAINING_NEEDED,
  ResolveFlowOptions.NO_RISK_IDENTIFICATION
];

export const conditionForDetailedExpSG80: string[] = [
  ResolveFlowOptions.TRAINING_NEEDED
];

export const conditionForDetailedExpRPA: string[] = [
  ResolveFlowOptions.TRAINING_NEEDED
];

export const conditionForDetailedExpRR: string[] = [
  ResolveFlowOptions.TRAINING_NEEDED,
  ResolveFlowOptions.NO_RISK_IDENTIFICATION
];

export const ControlDetailedReasonCodesACNAC: any = {
  trainingNeeded: [
    {
      text: ResolveFlowOptions.TRAINING_NEEDED_REGD_REAS_COMP,
      value: ResolveFlowOptions.TRAINING_NEEDED_REGD_REAS_COMP
    },
    {
      text: ResolveFlowOptions.MISSING_CUSTOMER_DATA,
      value: ResolveFlowOptions.MISSING_CUSTOMER_DATA
    },
    {
      text: ResolveFlowOptions.INCORRECT_LABEL_TYPE,
      value: ResolveFlowOptions.INCORRECT_LABEL_TYPE
    },
    {
      text: ResolveFlowOptions.MISSING_COMMENTS,
      value: ResolveFlowOptions.MISSING_COMMENTS
    },
    {
      text: ResolveFlowOptions.INSUFFICIENT_COMMENT,
      value: ResolveFlowOptions.INSUFFICIENT_COMMENT
    }
  ],
  noRisk: [
    {
      text: ResolveFlowOptions.COMP_CALCULATED_CORRECTLY,
      value: ResolveFlowOptions.COMP_CALCULATED_CORRECTLY
    },
    {
      text: ResolveFlowOptions.OTHER,
      value: ResolveFlowOptions.OTHER
    }
  ],
  unreasonsableCompensation: [
    {
      text: ResolveFlowOptions.FRAUDULENT_CO_WORKER_BEHAVIOUR,
      value: ResolveFlowOptions.FRAUDULENT_CO_WORKER_BEHAVIOUR
    },
    {
      text: ResolveFlowOptions.FRAUDULENT_CUSTOMER_BEHAVIOUR,
      value: ResolveFlowOptions.FRAUDULENT_CUSTOMER_BEHAVIOUR
    },
    {
      text: ResolveFlowOptions.OTHER,
      value: ResolveFlowOptions.OTHER
    }
  ]
};

export const ControlDetailedReasonCodesRR: any = {
  trainingNeeded: [
    {
      text: ResolveFlowOptions.MULTIPLE_INFO_FIELD_MISSING,
      value: ResolveFlowOptions.MULTIPLE_INFO_FIELD_MISSING
    },
    {
      text: ResolveFlowOptions.MISSING_FIRST_NAME,
      value: ResolveFlowOptions.MISSING_FIRST_NAME
    },
    {
      text: ResolveFlowOptions.MISSING_LAST_NAME,
      value: ResolveFlowOptions.MISSING_LAST_NAME
    },
    {
      text: ResolveFlowOptions.MISSING_ADDRESS,
      value: ResolveFlowOptions.MISSING_ADDRESS
    },
    {
      text: ResolveFlowOptions.MISSING_ZIP_CODE,
      value: ResolveFlowOptions.MISSING_ZIP_CODE
    },
    {
      text: ResolveFlowOptions.MISSING_PHONE_NUMBER,
      value: ResolveFlowOptions.MISSING_PHONE_NUMBER
    },
    {
      text: ResolveFlowOptions.MISSING_COMMENTS,
      value: ResolveFlowOptions.MISSING_COMMENTS
    }
  ],
  noRisk: [
    {
      text: ResolveFlowOptions.REVIEWED_CUSTOMER_HISTORY,
      value: ResolveFlowOptions.REVIEWED_CUSTOMER_HISTORY
    },
    {
      text: ResolveFlowOptions.OTHER,
      value: ResolveFlowOptions.OTHER
    }
  ],
  risk: [
    {
      text: ResolveFlowOptions.FRAUDULENT_CO_WORKER_BEHAVIOR,
      value: ResolveFlowOptions.FRAUDULENT_CO_WORKER_BEHAVIOR
    },
    {
      text: ResolveFlowOptions.FRAUDULENT_CUSTOMER_BEHAVIOR,
      value: ResolveFlowOptions.FRAUDULENT_CUSTOMER_BEHAVIOR
    },
    {
      text: ResolveFlowOptions.OTHER,
      value: ResolveFlowOptions.OTHER
    }
  ],
  other: [
    {
      text: ResolveFlowOptions.OTHER,
      value: ResolveFlowOptions.OTHER
    }
  ]
};

export const ControlDetailedReasonCodesSG80: any = {
  trainingNeeded: [
    {
      text: ResolveFlowOptions.MISSING_COMMENTS,
      value: ResolveFlowOptions.MISSING_COMMENTS
    }
  ]
};

export const DETAIL_EXPLANATION_DE_LIMITER = "|";

export const RISK_CONTROL_FILTERS_KEY = "RISK_CONTROL_FILTERS_KEY";

export const RISK_CONTROL_CASES = "RISK_CONTROL_CASES";

export const RISK_CONTROL_CASES_REQUEST_PARAMS =
  "RISK_CONTROL_CASES_REQUEST_PARAMS";
